<template>
    <div>

        <!-- URGENT POPUP -->
        <v-layout v-if="urgentData" row justify-center>
            <v-dialog v-model="mustShowUrgentPopup" persistent max-width="600">
                <v-card class="no-padding">
                    <v-card-text class="text-center no-padding">

                        <div class="warning-ambulance" v-bind:style="{'background-color': decisionColor}">

                            <img src="../../../assets/svg/ambulance_popup.svg" alt="medicine logo" width="104" height="104">

                            <h2 class="font-weight-regular" v-html="urgentData.decisionItem1Headline"></h2>
                            <p v-if="urgentData.decisionItem1Text" v-html="urgentData.decisionItem1Text">

                            </p>

                            <div v-if="urgentData.decisionItems2Texts">
                                <br />
                                <ul>
                                    <li v-for="decisionItems2Text in urgentData.decisionItems2Texts" v-html="decisionItems2Text"></li>
                                </ul>
                            </div>

                            <p v-if="urgentData.emergencyNumber">Emergency number: {{ urgentData.emergencyNumber</p>
                        </div>
                        <div class="arrow-down" v-bind:style="{'border-top-color': decisionColor}"></div>

                    </v-card-text>
                    <v-card-actions class="text-center warning-actions">

                        <div class="continue">
                            <v-btn @click="goToPfEvaluationPage()" class="btn-evaluation">{{text('api.button.finish')}}</v-btn>
                        </div>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-layout>

    </div>
</template>

<!-- ################################################################## -->

<script>
    import {mapGetters} from 'vuex';

    export default {
        name: 'PfUrgentPopup',

        computed: {
            ...mapGetters({
                urgentData: 'AssessmentAlertsStore/getUrgentData',
                mustShowUrgentPopup: 'AssessmentAlertsStore/getMustShowUrgentPopup',
                decisionColor: 'AssessmentAlertsStore/getDecisionColor',
            })
        },
        mounted() { },
        methods: {
            hideUrgentPopup() {
                this.$store.commit('AssessmentAlertsStore/setMustShowUrgentPopup', false);
            },

            goToPfEvaluationPage() {

                this.$store.commit('PfEvaluationStore/setUsedShortcut', true);
                this.$store.commit('AssessmentAlertsStore/setMustShowUrgentPopup', false);

                this.$router.push('/pathfinder/scoring');
            }
        },
        created: function() {
            document.addEventListener('keyup', this.escapeKeyListenerUrg);
        },
        destroyed: function() {
            document.removeEventListener('keyup', this.escapeKeyListenerUrg);
        }

    }
</script>

<!-- ################################################################## -->

<style lang="scss" scoped>

    .warning-ambulance {
        position:relative;
        background-color: $color-brand-primary;
        height:auto !important;
        width:100% !important;
        color: $color-headings-text;
        padding: 10px 20px 20px 20px;

        ul li {
            list-style-type: none;
        }
    }

    .arrow-down {
        width: 0;
        height: 0;
        border-left: 20px solid transparent;
        border-right: 20px solid transparent;
        right: 47%;
        border-top: 20px solid;
        position: absolute;
        border-top-color: $color-brand-primary;
    }

    .close-warning {

        padding-bottom: 50px;



        span {

            float: right;
            padding: 10px;

            .icon {
                color: $color-gray;
            }

            &:hover {
                cursor: pointer;
            }
        }


    }

    .warning-actions {
        display: block;
        border-top: none;
        padding: 40px 0 20px;


        .continue {
            padding: 0 20px;

            &:hover {
                cursor: pointer;
            }
        }
    }

</style>




// WEBPACK FOOTER //
// src/pathfinder/components/shared/PfUrgentPopup.vue